(function () {
  'use strict';

  /* Révision 11/09/2026 (L'ARCHITECTE 9). Un seul ajout de comportement, mesuré au préalable :
     au repli ("Voir moins"), la grille perdait ~670 px de hauteur d'un coup et le script ne
     gérait pas la position de lecture. Un utilisateur descendu regarder les photos se retrouvait
     face à du contenu qui avait sauté, sans le bouton en vue. Désormais, si l'ancre du bouton
     est sortie de l'écran au moment du repli, on la ramène en vue par un défilement doux
     (immédiat sous prefers-reduced-motion). Rien d'autre ne change. */

  if (window.__efaProductGalleryDisclosure) return;
  window.__efaProductGalleryDisclosure = true;

  var GRID_SELECTOR = '.l4pr:not(.slider):not(.s4wi):not(.mobile-only)';
  var BUTTON_SELECTOR = '[data-efa-gallery-button]';
  var HOST_SELECTOR = '[data-efa-gallery-toggle]';
  var OPEN_CLASS = 'efa-gallery-expanded';
  var frame = 0;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function resetPosition(host) {
    host.style.setProperty('--efa-gallery-shift-x', '0px');
    host.style.setProperty('--efa-gallery-shift-y', '0px');
    host.classList.remove('is-positioned');
  }

  function positionToggle(grid) {
    var host = grid.querySelector(HOST_SELECTOR);
    if (!host) return;

    resetPosition(host);
    if (!grid.classList.contains(OPEN_CLASS)) return;

    var anchor = host.parentElement;
    if (!anchor) return;

    var gridRect = grid.getBoundingClientRect();
    var anchorRect = anchor.getBoundingClientRect();
    var shiftX = gridRect.left + gridRect.width / 2 - (anchorRect.left + anchorRect.width / 2);
    var shiftY = gridRect.bottom - anchorRect.bottom;

    if (!Number.isFinite(shiftX) || !Number.isFinite(shiftY)) return;

    host.style.setProperty('--efa-gallery-shift-x', shiftX.toFixed(2) + 'px');
    host.style.setProperty('--efa-gallery-shift-y', shiftY.toFixed(2) + 'px');
    host.classList.add('is-positioned');
  }

  function positionOpenGalleries() {
    document.querySelectorAll(GRID_SELECTOR + '.' + OPEN_CLASS).forEach(positionToggle);
  }

  function schedulePosition() {
    if (frame) window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(function () {
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        positionOpenGalleries();
      });
    });
  }

  /* Au repli : si l'ancre du bouton (le 4e media) est passee au-dessus de l'ecran,
     on la ramene en bas de la fenetre, pour que l'utilisateur retrouve le bouton
     qu'il vient de cliquer et la fin des photos visibles. */
  function keepAnchorInView(host) {
    var anchor = host.parentElement;
    if (!anchor) return;
    var rect = anchor.getBoundingClientRect();
    var viewportH = window.innerHeight || document.documentElement.clientHeight;
    if (rect.bottom < 0 || rect.top > viewportH) {
      anchor.scrollIntoView({ block: 'end', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    }
  }

  function hydrate(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      var grid = button.closest('.l4pr');
      if (grid && grid.id) button.setAttribute('aria-controls', grid.id);
    });
  }

  function setExpanded(button, expanded) {
    var host = button.closest(HOST_SELECTOR);
    var grid = host && host.closest(GRID_SELECTOR);
    if (!host || !grid) return;

    if (grid.id) button.setAttribute('aria-controls', grid.id);
    grid.classList.toggle(OPEN_CLASS, expanded);
    host.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (expanded) {
      resetPosition(host);
      schedulePosition();
    } else {
      resetPosition(host);
      keepAnchorInView(host);
    }
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;

    var host = button.closest(HOST_SELECTOR);
    var grid = host && host.closest(GRID_SELECTOR);
    if (!grid) return;

    event.preventDefault();
    event.stopPropagation();
    setExpanded(button, button.getAttribute('aria-expanded') !== 'true');
  });

  window.addEventListener('resize', schedulePosition, { passive: true });
  window.addEventListener('orientationchange', schedulePosition, { passive: true });

  document.addEventListener('load', function (event) {
    if (event.target instanceof HTMLImageElement && event.target.closest(GRID_SELECTOR + '.' + OPEN_CLASS)) {
      schedulePosition();
    }
  }, true);

  document.addEventListener('shopify:section:load', function (event) {
    hydrate(event.target);
    schedulePosition();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hydrate(document); }, { once: true });
  } else {
    hydrate(document);
  }
})();


/* ============================================================================
   EFA - GALERIE PRODUIT MOBILE : boucle, barre + fraction, teinte, swipe.
   L'ARCHITECTE 9, 14/09/2026, sur les trois defauts signales par Timothee.

   POURQUOI ICI. Ce fichier est deja charge par sections/main-product.liquid (L4,
   defer) sur toutes les fiches : aucune requete ajoutee, aucune ligne de Liquid a
   toucher, et le CSS part dans efa-product-gallery.css, charge L3. assets/custom.js
   (coeur du theme) n'est pas modifie : on REPREND l'instance qu'il cree.

   1. « la barre s'arrete a 5 sur mon telephone, 8 au minimum desktop ». Ce n'est pas
      un JS peu rigoureux : Swiper rend bien 8 vignettes, mais le theme les MASQUE par
      paliers de largeur (page-product.css : .swiper-pagination-bullet:nth-child(n+7)
      {display:none} sous 400 px, n+6 sous 350...). Des vignettes de 36 px alignees :
      le compte ne peut jamais suivre le nombre de photos. On remplace la pagination
      par une BARRE DE PROGRESSION native de Swiper (largeur = (index+1)/total) et une
      FRACTION « 01 / 08 ». Le total est capture AVANT la reprise, donc jamais fausse
      par les slides de boucle.
   2. « arrive a la derniere image on ne peut plus scroll a droite ; l'ideal serait que
      ca loop dans les deux sens ». Le theme pose loop:false, sans rewind. On repasse la
      meme instance en loop (rewind si 2 photos seulement, ou le loop n'est pas permis).
   3. « la barre et le chiffre passent en blanc si le bg est sombre... dynamiquement
      d'une photo a l'autre ». On echantillonne la bande basse de l'image active (canvas
      24x3, meme origine CDN), luminance WCAG, seuil 0,2004 (point ou blanc et #191919
      donnent le meme contraste, 4,19:1). Un seul calcul par src, en cache, apres
      decode(), jamais si l'image n'est pas chargee. Canvas teinte -> on renonce.
   4. LE SWIPE (cause 2 sur 2 ; la cause 1 est dans le CSS, voir efa-product-gallery.css).
      MESURE au banc tactile reel : avec longSwipesRatio 0,5, tout glissement juge
      « long » (> 300 ms) devait depasser 50 % de la largeur, soit 187 px a 375 px.
      Matrice : 100, 150 et 200 px echouaient TOUS, quelle que soit la duree ; 240 px
      passait. A 0,2 : 100, 150, 200 px passent, 80 echoue. Un demi-ecran glisse suffit.

   COUT : ~2,9 Ko sans commentaires, 0 dependance, 0 requete, aucun minuteur (un seul
   MutationObserver sur la section, rappel O(1)). lazyPreloadPrevNext:1 charge la voisine
   de chaque cote - 2 images de plus au chargement, et c'est ce qui evite l'image blanche
   quand on revient sur la derniere photo par la gauche.
   ============================================================================ */
(function () {
  'use strict';

  var SEUIL = 0.2004;
  var ul0 = document.getElementById('main-product-slider');
  if (!ul0 || !(ul0.getAttribute('data-media-size') > 1)) return;
  var sec = ul0.closest('.shopify-section') || document.body;
  var cache = {}, ctx, mort = false;

  function lin(c) { c /= 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function poser(ul, img, sombre) { if (ul.efaImg === img) ul.classList.toggle('is-dark', sombre); }

  function teinte(ul, img) {
    var src = img.currentSrc || img.src, v = cache[src];
    if (mort || !src) return;
    if (v !== undefined) { if (v !== null) poser(ul, img, v); return; }
    if (!img.complete) { img.addEventListener('load', function () { teinte(ul, img); }, { once: true }); return; }
    cache[src] = null;
    (img.decode ? img.decode() : Promise.resolve()).then(function () {
      var w = img.naturalWidth, h = img.naturalHeight, d, i, s = 0;
      if (!w || !h) { delete cache[src]; return; }
      ctx = ctx || document.createElement('canvas').getContext('2d', { willReadFrequently: true });
      ctx.canvas.width = 24; ctx.canvas.height = 3;
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, 24, 3);
      ctx.drawImage(img, 0, h * 0.88, w, h * 0.12, 0, 0, 24, 3);
      d = ctx.getImageData(0, 0, 24, 3).data;
      for (i = 0; i < d.length; i += 4) s += 0.2126 * lin(d[i]) + 0.7152 * lin(d[i + 1]) + 0.0722 * lin(d[i + 2]);
      cache[src] = s / (d.length / 4) < SEUIL;
      poser(ul, img, cache[src]);
    })['catch'](function (e) {
      delete cache[src];
      if (e && e.name === 'SecurityError') mort = true;
    });
  }

  function prendre(ul) {
    var outer = ul.querySelector('.swiper-outer'), old = outer && outer.swiper, cont, num, sw;
    if (!old || old.efaGal || !outer.clientWidth) return;
    cont = ul.querySelector('.swiper-custom-bullets');
    if (!cont) return;

    var Ctor = old.constructor;
    var total = old.slides.length;
    var depart = old.realIndex;
    var base = Object.assign({}, old.passedParams);
    var p = Object.assign({}, base);
    p.pagination = Object.assign({}, base.pagination, { type: 'progressbar', clickable: false });
    p.loop = total > 2;
    p.rewind = !p.loop;
    p.initialSlide = depart;
    p.longSwipesRatio = 0.2;
    p.lazyPreloadPrevNext = 1;

    num = cont.querySelector('.efa-gal__num');
    if (!num) { num = document.createElement('span'); num.className = 'efa-gal__num'; cont.appendChild(num); }

    function maj(s) {
      var slide = s.slides[s.activeIndex], img = slide && slide.querySelector('img');
      num.textContent = pad(s.realIndex + 1) + ' / ' + pad(total);
      ul.efaImg = img;
      if (img) teinte(ul, img);
    }
    p.on = Object.assign({}, base.on, { paginationUpdate: maj, slideChange: maj });

    old.destroy(true, true);
    ul.classList.add('efa-gal');
    try {
      sw = new Ctor(outer, p);
    } catch (e) {
      ul.classList.remove('efa-gal');
      try { new Ctor(outer, base); } catch (e2) {}
      return;
    }
    sw.efaGal = true;
    maj(sw);
  }

  function tenter() {
    var ul = document.getElementById('main-product-slider');
    if (ul && ul.classList.contains('mobile-only')) prendre(ul);
  }

  new MutationObserver(tenter).observe(sec, { childList: true, subtree: true });
  tenter();
})();

/* =====================================================================================
   LIGHTBOX DE LA GALERIE PRODUIT (Fancybox 4.0.31) · ajout du 06/10/2026, CORE WEB VITALS,
   sur GO de Timothée. Audit et mesures : CORE_WEB/vitals/_mesures_2026-10/audit_lightbox_produit_2026-10-05.md
   Le cœur du thème (custom-async.js, plugin-fancybox.js, async-fancybox.css) n'est PAS modifié :
   on règle Fancybox.defaults au moment exact où le plugin se charge, avant que le thème
   ne crée la fenêtre. Les deux chemins d'ouverture du thème (1re ouverture par custom-async.js,
   suivantes par l'ouvreur automatique de Fancybox) reçoivent donc les mêmes réglages.
   1. Un clic DANS la fenêtre blanche ne ferme plus ; seuls la croix, Échap et le fond gris ferment.
   2. Zoom léger : au plus ZOOM_MAX fois la taille d'ouverture (jamais la taille native de la photo).
      Clic sur ordinateur, double-tap sur écran tactile, pincement : l'image seule, jamais la page.
   3. Ouverture et fermeture en fondu du cadre ET de l'image, sans saut de la page derrière.
   Retour arrière : supprimer ce bloc entier (de cette bannière à la fin du fichier).
   ===================================================================================== */
(function () {
  'use strict';

  if (window.__efaLightbox) return;
  window.__efaLightbox = true;

  /* 08/10/2026 : zoom DÉSACTIVÉ à la demande de Timothée (avant : 1.5). Retour arrière : remettre 1.5 et les
     réglages click / doubleClick / wheel ci-dessous. */
  var ZOOM_MAX = 1;

  var CSS = [
    /* Pendant que la fenêtre est ouverte, aucun geste ne revient au navigateur :
       le pincement agit sur l'image (Panzoom), jamais sur la page ni sur le cadre. */
    '.fancybox__container{touch-action:none}',
    /* Fondu d'ouverture. À la toute première ouverture, la feuille async-fancybox.css arrive APRÈS la
       création de la fenêtre : le cadre reste transparent (efa-lb-attente) jusqu'à son arrivée, puis
       le fondu démarre (efa-lb-anim). Filet : au bout de 3 s, la fenêtre s'affiche quoi qu'il arrive. */
    '@keyframes efa-lb-in{from{opacity:0}to{opacity:1}}',
    '@keyframes efa-lb-out{from{opacity:1}to{opacity:0}}',
    '.fancybox__container.efa-lb-attente{opacity:0!important}',
    '.fancybox__container.efa-lb-anim.is-animated:not(.is-closing){animation:efa-lb-in .22s ease-out both}',
    '.fancybox__container.is-animated.is-closing{animation:efa-lb-out .2s ease-in both}',
    '.efa-lb-in{animation:efa-lb-in .22s ease-out both}',
    '.efa-lb-out{animation:efa-lb-out .2s ease-in both}',
    '.fancybox__container.is-closing .fancybox-throwOutUp,.fancybox__container.is-closing .fancybox-throwOutDown{animation-duration:.2s}',
    /* La barre de défilement disparaît à l'ouverture. Fancybox compense par un padding sur <body>,
       mais screen.css impose « body{padding:0 !important} » : la page sautait de 10 px. On rend la
       compensation (largeur mesurée à l'ouverture, 0 sur mobile). « scrollbar-gutter » a été écarté :
       mesuré le 06/10, il ramenait la page en haut après un zoom. */
    'html.with-fancybox body.compensate-for-scrollbar{padding-right:var(--efa-lb-sbw,0px)!important}',
    /* Curseur loupe sur une image zoomable (le CSS personnalisé impose « grab » en !important). */
    '.fancybox__carousel .fancybox__slide.can-zoom_in .fancybox__content{cursor:zoom-in!important}',
    '.fancybox__carousel .fancybox__slide.can-zoom_out .fancybox__content{cursor:zoom-out!important}',
    '@media (prefers-reduced-motion:reduce){.fancybox__container.is-animated,.efa-lb-in,.efa-lb-out{animation-duration:.01s!important}}'
  ].join('\n');

  function injecterCss() {
    if (document.getElementById('efa-lightbox-css')) return;
    var s = document.createElement('style');
    s.id = 'efa-lightbox-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function tactile() {
    return !!(window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches);
  }

  function regler(F) {
    if (!F || !F.defaults || F.__efaRegle) return;
    F.__efaRegle = true;
    var d = F.defaults;
    d.showClass = 'efa-lb-in';
    d.hideClass = 'efa-lb-out';
    d.on = Object.assign({}, d.on, {
      initLayout: function (fb) {
        var C = fb && fb.$container;
        if (!C) return;
        if (cssPrete()) { lancerFondu(C); return; }
        C.classList.add('efa-lb-attente');
        setTimeout(function () { if (C.classList.contains('efa-lb-attente')) lancerFondu(C); }, 3000);
      },
      init: function (fb) {
        fb.__efaSy = window.pageYOffset;
        var h = document.documentElement;
        h.style.setProperty('--efa-lb-sbw', Math.max(0, window.innerWidth - h.clientWidth) + 'px');
      },
      /* Mesuré sur mobile le 06/10 (thème non modifié compris) : la page derrière la fenêtre se
         décale pendant l'ouverture (420 → 729 px). À la fermeture, on rend au client sa position. */
      destroy: function (fb) {
        var y = fb && fb.__efaSy;
        if (typeof y !== 'number') return;
        Promise.resolve().then(function () {
          if (Math.abs(window.pageYOffset - y) <= 1) return;
          /* screen.css pose « scroll-behavior: smooth » sur <html> : sans cette bascule, la page
             défilerait sous les yeux du client au lieu d'être déjà à sa place. */
          var h = document.documentElement, avant = h.style.scrollBehavior;
          h.style.scrollBehavior = 'auto';
          window.scrollTo(window.pageXOffset, y);
          h.style.scrollBehavior = avant;
        });
      },
      click: function (fb, e) {
        var t = e && e.target;
        if (t && t.closest && t.closest('.fancybox__carousel')) return false;
      }
    });
    var img = d.Image || {};
    d.Image = Object.assign({}, img, {
      zoom: false,
      click: false,
      doubleClick: false,
      wheel: false,
      Panzoom: Object.assign({}, img.Panzoom, {
        maxScale: function () {
          var c = this.content || {};
          var natif = c.origWidth > 0 && c.fitWidth > 0 ? c.origWidth / c.fitWidth : 1;
          return Math.max(1, Math.min(ZOOM_MAX, natif));
        }
      })
    });
  }

  function cssPrete() {
    var l = document.getElementById('css-fancybox');
    if (!l) return false;
    try { return !!(l.sheet && l.sheet.cssRules.length); } catch (e) { return !!l.sheet; }
  }

  function lancerFondu(C) {
    if (!C || !C.classList) return;
    C.classList.remove('efa-lb-attente');
    C.classList.add('efa-lb-anim');
  }

  function marquerCss() {
    if (!cssPrete()) return;
    var enAttente = document.querySelectorAll('.fancybox__container.efa-lb-attente');
    for (var i = 0; i < enAttente.length; i++) lancerFondu(enAttente[i]);
  }

  /* Phase de capture : passe AVANT le onload du thème, donc avant la création de la fenêtre. */
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (!t || !t.tagName) return;
    if (t.tagName === 'SCRIPT' && /plugin-fancybox/.test(t.src || '')) regler(window.Fancybox);
    if (t.tagName === 'LINK' && t.id === 'css-fancybox') marquerCss();
  }, true);

  /* Préchargement à l'intention (survol, toucher, focus d'une vignette) : la feuille de styles est
     appliquée et le script mis en cache avant le clic. Le script n'est PAS exécuté ici. */
  var prechauffe = false;
  function prechauffer(e) {
    if (prechauffe) return;
    var t = e.target;
    if (!t || !t.closest || !t.closest('[data-fancybox]')) return;
    prechauffe = true;
    var fp = window.filepaths || {};
    if (fp.a_css_fancybox && typeof window.new_css === 'function') window.new_css('css-fancybox', fp.a_css_fancybox);
    if (fp.a_js_fancybox && !window.Fancybox) {
      var p = document.createElement('link');
      p.rel = 'preload';
      p.as = 'script';
      p.href = fp.a_js_fancybox;
      document.head.appendChild(p);
    }
  }
  document.addEventListener('pointerover', prechauffer, { passive: true });
  document.addEventListener('touchstart', prechauffer, { passive: true });
  document.addEventListener('focusin', prechauffer);

  injecterCss();
  if (window.Fancybox) regler(window.Fancybox);
  marquerCss();
})();
